// src/App.js
import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// Language Context
import { LanguageProvider } from './pages/LanguageContext';

// Components
import Header from './components/Header';
import Footer from './components/Footer';

// Pages
import Home from './pages/Home';
import Contact from './pages/Contact';
import ClientsAndWork from './pages/ClientsAndWork';
import EnvironmentalRole from './pages/EnvironmentalRole';
import SmartSecurityPage from './pages/SmartSecurityPage';
import SmartClimateControlPage from './pages/SmartClimateControlPage';
import MatterPage from './pages/MatterPage';
import ZigbeePage from './pages/ZigbeePage';
import WifiPage from './pages/WifiPage';
import CareerPage from './pages/CareerPage';
import AboutUsPage from './pages/AboutUs';
import SmartHomeAutomationPage from './pages/SmartHomeAutomationPage';
import ScrollToTop from './pages/ScrollToTop';

function App() {
  // ✅ Always start in dark mode on every visit (no persistence)
  const [darkMode, setDarkMode] = useState(true);

  // Init AOS once
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      easing: 'ease-in-out',
    });
  }, []);

  // Apply theme classes (no localStorage)
  useEffect(() => {
    const root = document.documentElement;
    const body = document.body;
    root.classList.toggle('dark', darkMode);
    root.classList.toggle('light', !darkMode);
    body.classList.toggle('dark', darkMode);
    body.classList.toggle('light', !darkMode);
  }, [darkMode]);

  return (
    <LanguageProvider>
      <Router>
        <ScrollToTop />
        <div className="App">
          <Header darkMode={darkMode} setDarkMode={setDarkMode} />
          <main style={{ minHeight: '80vh', paddingTop: '90px' }}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/ClientsAndWork" element={<ClientsAndWork />} />
              <Route path="/EnvironmentalRole" element={<EnvironmentalRole />} />
              <Route path="/services/home-security" element={<SmartSecurityPage />} />
              <Route path="/services/industrial-application" element={<SmartClimateControlPage />} />
              <Route path="/technology/matter" element={<MatterPage />} />
              <Route path="/technology/zigbee" element={<ZigbeePage />} />
              <Route path="/technology/wifi" element={<WifiPage />} />
              <Route path="/CareerPage" element={<CareerPage />} />
              <Route path="/AboutUsPage" element={<AboutUsPage />} />
              <Route path="/SmartHomeAutomationPage" element={<SmartHomeAutomationPage />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </LanguageProvider>
  );
}

export default App;
